const map = {
	"./add-package-24.svg": 5493,
	"./arrow-24.svg": 9754,
	"./arrow-48x24.svg": 6974,
	"./avatar-24.svg": 5970,
	"./bell-24.svg": 2874,
	"./briefcase-24.svg": 4595,
	"./check-24.svg": 8895,
	"./check-badge-16.svg": 6786,
	"./chefhat-24.svg": 434,
	"./chevron-24.svg": 904,
	"./chevron-thin-24.svg": 3018,
	"./copy-24.svg": 2134,
	"./cross-24.svg": 3055,
	"./delivery-van-24.svg": 4183,
	"./download-24.svg": 9375,
	"./download-document-24.svg": 7045,
	"./duration-24.svg": 831,
	"./edit-24.svg": 2347,
	"./eye-24.svg": 6478,
	"./eye-off-24.svg": 6566,
	"./facebook-24.svg": 4499,
	"./facebook-filled-24.svg": 2608,
	"./facebook-round-24.svg": 1378,
	"./filter-24.svg": 7317,
	"./filter-alternative-24.svg": 3767,
	"./gears-24.svg": 6207,
	"./grid-24.svg": 4055,
	"./info-circle-16.svg": 3067,
	"./info-circle-24.svg": 880,
	"./instagram-24.svg": 7771,
	"./instagram-filled-24.svg": 1912,
	"./lactosefree-24.svg": 3760,
	"./linkedin-24.svg": 9917,
	"./linkedin-filled-24.svg": 8154,
	"./list-24.svg": 4655,
	"./location-24.svg": 260,
	"./logo-apple-24.svg": 2533,
	"./logo-google-24.svg": 5798,
	"./mail-24.svg": 3436,
	"./menu-24.svg": 796,
	"./orthomol-logo-24.svg": 6441,
	"./present-24.svg": 9680,
	"./print-24.svg": 2004,
	"./quote-64.svg": 5967,
	"./rotate-24.svg": 564,
	"./search-24.svg": 9027,
	"./shopping-cart-24.svg": 1534,
	"./shopping-cart-add-24.svg": 1144,
	"./telephone-24.svg": 9819,
	"./vegan-24.svg": 2002,
	"./vegetarian-24.svg": 7479,
	"./voucher-24.svg": 6745,
	"./warning-24.svg": 499,
	"./web-24.svg": 4921,
	"./whatsapp-24.svg": 8817,
	"./x-24.svg": 39,
	"./xing-24.svg": 7703,
	"./xing-filled-24.svg": 9340,
	"./youtube-24.svg": 9722,
	"./youtube-filled-24.svg": 2811,
	"./zoom-24.svg": 7264,
	"./zoom-in-24.svg": 4462,
	"./zoom-out-24.svg": 3865
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9351;